import { render, staticRenderFns } from "./Tourists.vue?vue&type=template&id=e5712a7c&"
import script from "./Tourists.vue?vue&type=script&lang=js&"
export * from "./Tourists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports